/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetToolUsageSummaryPayload,
  GetToolUsageSummaryPayload$Outbound,
  GetToolUsageSummaryPayload$outboundSchema,
} from "../components/gettoolusagesummarypayload.js";

export type GetToolUsageClientsSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetToolUsageClientsSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetToolUsageClientsSecurity = {
  option1?: GetToolUsageClientsSecurityOption1 | undefined;
  option2?: GetToolUsageClientsSecurityOption2 | undefined;
};

export type GetToolUsageClientsRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getToolUsageSummaryPayload: GetToolUsageSummaryPayload;
};

/** @internal */
export type GetToolUsageClientsSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetToolUsageClientsSecurityOption1$outboundSchema: z.ZodMiniType<
  GetToolUsageClientsSecurityOption1$Outbound,
  GetToolUsageClientsSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getToolUsageClientsSecurityOption1ToJSON(
  getToolUsageClientsSecurityOption1: GetToolUsageClientsSecurityOption1,
): string {
  return JSON.stringify(
    GetToolUsageClientsSecurityOption1$outboundSchema.parse(
      getToolUsageClientsSecurityOption1,
    ),
  );
}

/** @internal */
export type GetToolUsageClientsSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetToolUsageClientsSecurityOption2$outboundSchema: z.ZodMiniType<
  GetToolUsageClientsSecurityOption2$Outbound,
  GetToolUsageClientsSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getToolUsageClientsSecurityOption2ToJSON(
  getToolUsageClientsSecurityOption2: GetToolUsageClientsSecurityOption2,
): string {
  return JSON.stringify(
    GetToolUsageClientsSecurityOption2$outboundSchema.parse(
      getToolUsageClientsSecurityOption2,
    ),
  );
}

/** @internal */
export type GetToolUsageClientsSecurity$Outbound = {
  Option1?: GetToolUsageClientsSecurityOption1$Outbound | undefined;
  Option2?: GetToolUsageClientsSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetToolUsageClientsSecurity$outboundSchema: z.ZodMiniType<
  GetToolUsageClientsSecurity$Outbound,
  GetToolUsageClientsSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetToolUsageClientsSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetToolUsageClientsSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getToolUsageClientsSecurityToJSON(
  getToolUsageClientsSecurity: GetToolUsageClientsSecurity,
): string {
  return JSON.stringify(
    GetToolUsageClientsSecurity$outboundSchema.parse(
      getToolUsageClientsSecurity,
    ),
  );
}

/** @internal */
export type GetToolUsageClientsRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetToolUsageSummaryPayload: GetToolUsageSummaryPayload$Outbound;
};

/** @internal */
export const GetToolUsageClientsRequest$outboundSchema: z.ZodMiniType<
  GetToolUsageClientsRequest$Outbound,
  GetToolUsageClientsRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getToolUsageSummaryPayload: GetToolUsageSummaryPayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getToolUsageSummaryPayload: "GetToolUsageSummaryPayload",
    });
  }),
);

export function getToolUsageClientsRequestToJSON(
  getToolUsageClientsRequest: GetToolUsageClientsRequest,
): string {
  return JSON.stringify(
    GetToolUsageClientsRequest$outboundSchema.parse(getToolUsageClientsRequest),
  );
}
